import Service from "../Service";
import { domain } from '../Constants'

const auth = {

    // auth
    onLogIn(email, password) {
        return Service.post(`/api/login`,{
            email: email,
            password: password
        });
    },

    onLogOut(token) {
      return Service.get(`/api/logout`, { headers: { Authorization: `Bearer ${token}` } });
    },

    getUserDetail(data) {
        return Service.get(`/api/details`, { headers: { Authorization: `Bearer ${data.token}` } });
    },


    // User manager
    getAllAccountPaginate(data) {
        let page = data.page ? data.page : 1;
        return Service.get(`/api/user?page=${page}`, { headers: { Authorization: `Bearer ${data.token}` } });
    },

    searchName(data) {
        return Service.post(`api/user-account/search`, {
            keyword: data.keyword
        }, {
            headers: { Authorization: `Bearer ${data.token}` }
        });
    },

    getAccount(data) {
        return Service.get(`/api/user/${data.id}`, { headers: { Authorization: `Bearer ${data.token}` } });
    },

    createAccount(data) {
        return Service.post(`/api/user`,{
            first_name: data.first_name,
            last_name: data.last_name,
            email: data.email,
            username: data.username,
            password: data.password,
            c_password: data.c_password
        }, {
            headers: { Authorization: `Bearer ${data.token}` }
        });
    },

    editAccount(data) {
        return Service.put(`/api/user/${data.id}`, {
            first_name: data.first_name,
            last_name: data.last_name,
            // email: data.email,
            username: data.username,
            password: data.password,
            c_password: data.c_password
        }, {
            headers: { Authorization: `Bearer ${data.token}` }
        });
    },

    deleteAccount(data) {
        return Service.delete(`/api/user/${data.id}`, { headers: { Authorization: `Bearer ${data.token}` } });
    }

};

export default auth;
